import {countWeeks} from 'shared/utils/dateTime';
import {futureDaysCount} from 'ui/utils/core';
import {valueOf} from 'ui/keyboard';

export function createPayload({
  userInput,
  budget,
  settingsView,
}: AppState): StartBudgetEventPayload {
  const amount = valueOf(userInput.keyboard);
  const days = futureDaysCount(budget, settingsView);
  const weeks = countWeeks(days);
  return {amount, days, weeks};
}
